import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Item } from '@atlassian/jira-software-roadmap-timeline-table/src/common/types/item.tsx';

export const createGetIsNudgeVisible =
	(id: IssueId): ((canCreateChild: boolean, firstParentItem: Item | undefined) => boolean) =>
	(canCreateChild, firstParentItem) =>
		canCreateChild && firstParentItem?.id === id;
